import { getSettings } from "./../services/settingsServices";

let saisonActive = "";

const fetchSaisonActive = async () => {
  try {
    const settingsData = await getSettings();

    if (settingsData && settingsData.length > 0) {
      saisonActive = settingsData[0].saison_active;
    }
  } catch (error) {
    console.error("Erreur lors de la récupération des paramètres :", error);
  }
};

fetchSaisonActive();

const getCategory = (dateOfBirth) => {
  if (!dateOfBirth || !saisonActive) return "Inconnu";

  const birthYear = new Date(dateOfBirth).getFullYear();
  const startYear = parseInt(saisonActive.split("-")[0], 10);

  if (Number.isNaN(birthYear) || Number.isNaN(startYear)) {
    return "Inconnu";
  }

  // Eveils : avant Mini poussins
  if (birthYear >= startYear - 3) {
    return "Eveil";
  }

  if (birthYear >= startYear - 5 && birthYear <= startYear - 4) {
    return "Mini poussin";
  }

  if (birthYear >= startYear - 7 && birthYear <= startYear - 6) {
    return "Poussin";
  }

  if (birthYear >= startYear - 9 && birthYear <= startYear - 8) {
    return "Pupille";
  }

  if (birthYear >= startYear - 11 && birthYear <= startYear - 10) {
    return "Benjamin";
  }

  if (birthYear >= startYear - 13 && birthYear <= startYear - 12) {
    return "Minime";
  }

  if (birthYear >= startYear - 15 && birthYear <= startYear - 14) {
    return "Cadet";
  }

  if (birthYear >= startYear - 17 && birthYear <= startYear - 16) {
    return "Junior";
  }

  if (birthYear >= startYear - 20 && birthYear <= startYear - 18) {
    return "Espoir";
  }

  if (birthYear >= startYear - 45 && birthYear <= startYear - 35) {
    return "Vétéran 1";
  }

  if (birthYear >= startYear - 55 && birthYear <= startYear - 46) {
    return "Vétéran 2";
  }

  if (birthYear >= startYear - 65 && birthYear <= startYear - 56) {
    return "Vétéran 3";
  }

  if (birthYear >= startYear - 75 && birthYear <= startYear - 66) {
    return "Vétéran 4";
  }

  if (birthYear <= startYear - 76) {
    return "Vétéran 5";
  }

  if (birthYear <= startYear - 21) {
    return "Sénior";
  }

  return "Inconnu";
};

export default getCategory;